import { render } from "./Edit.vue?vue&type=template&id=5984046c"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Tags/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5984046c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5984046c', __exports__)) {
    api.reload('5984046c', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=5984046c", () => {
    api.rerender('5984046c', render)
  })

}


export default __exports__